<template>
  <div class="login_wrapper">
    <div class="container">
      <div class="box">
        <div class="login">
          <div class="title">用户登录</div>
          <div class="form login-input login-select">
            <!--<div class="row">-->
            <!--<div class="label">角色:</div>-->
            <!--<div class="value">-->
            <!--<el-select v-model="role" placeholder="采购单位">-->
            <!--<el-option-->
            <!--v-for="item in options"-->
            <!--:key="item.value"-->
            <!--:label="item.label"-->
            <!--:value="item.value">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</div>-->
            <!--</div>-->
            <div class="row">
              <div class="label">账号:</div>
              <div class="value">
                <el-input
                  placeholder="请输入账号"
                  v-model.trim="model.usercode"
                  clearable
                ></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">密码:</div>
              <div class="value">
                <el-input
                  type="password"
                  @keyup.enter.native="login"
                  placeholder="请输入密码"
                  v-model="model.password"
                  clearable
                ></el-input>
              </div>
            </div>
            <div class="row">
              <div class="label">验证码:</div>
              <div class="value">
                <el-input
                  placeholder="请输入验证码"
                  @keyup.enter.native="login"
                  v-model.trim="model.yzm"
                  clearable
                ></el-input>
              </div>
              <div><div v-html="imgyzm" @click="getYzm"></div></div>
              <div @click="getYzm" class="yzmbtn"><span>换一张</span></div>
            </div>
          </div>

          <div class="btn" @click="login">
            <div>登录</div>
          </div>
          <div class="lead">
            <div>
              没有账号<span @click="$router.push({ path: '/reg' })"
                >立即注册</span
              ><span @click="$router.push({ path: '/findCom' })">找回注册</span>
            </div>
            <span class="linkbtn" @click="$router.push({ path: '/forgotpwd' })"
              >忘记密码</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "../../utils/request";
import Md5 from "../../assets/js/md5";
import { saveTokens } from "../../utils/token";
export default {
  name: "Login",
  data() {
    return {
      role: "",
      imgyzm: "",
      imgyzmToken: "",
      options: [{ value: 1, label: "采购人" }],
      model: {
        usercode: "",
        password: "",
      },
    };
  },
  created() {
    if (this.$route.query.t) {
      request({
        method: "post",
        url: "/token/getCache",
        data: { key: this.$route.query.t },
      }).then((res) => {
        if (!Object.keys(res).length > 0) {
          let local = window.localStorage;
          local.clear();
        }
      });
    }
    this.getSysCode();
    this.getYzm();
    // let token = location.search ? location.search.substr(1).split('=')[1] : ''
    // console.log(this.$route.query.t)
  },
  methods: {
    getYzm() {
      request({
        method: "get",
        url: "/validate/getSvgCaptcha",
        data: {},
      }).then((res) => {
        this.imgyzm = res.img;
        this.imgyzmToken = res.imgyzmToken;
      });
    },
    async getSysCode() {
      this.options = await request({
        url: "/web/web/getSysCodeList",
        method: "get",
        params: { syscode: "comtype" },
      });
    },
    async login() {
      if (!this.model.usercode) {
        this.$message({
          message: "请输入用户名！",
          type: "warning",
        });
        return;
      } else if (!this.model.password) {
        this.$message({
          message: "请输入密码！",
          type: "warning",
        });
        return;
      } else if (!this.model.yzm) {
        this.$message({
          message: "请输入验证码！",
          type: "warning",
        });
        return;
      }

      let data = await request({
        url: "/web/web/login",
        method: "post",
        data: {
          usercode: this.model.usercode,
          password: Md5.md5(this.model.password),
          comtype: this.role,
          imgyzmToken: this.imgyzmToken,
          yzm: this.model.yzm,
          cosid: this.cosId,
        },
      });
      if (data && data.user) {
        delete data.user.userpassword;
        let user = data.user;
        user.token = data.token;
        saveTokens(data.token);
        this.$store.commit("changeState", { webLoginUser: user });
        this.$emit("change", 1);
      } else {
        this.getYzm();
      }
      // window.location.replace(`${this.obWebUrl}mainIndex?t=${data.token}`)
    },
  },
  computed: {
    ...mapGetters(["obWebUrl", "cosId"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .login_wrapper {
    
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-black;
    .container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: $color-black;
      /*padding-right: 40px;*/
      .box {
        border-radius: 3px;
        background-color: $color-bg-white;
        /*设计是425*/
        // width: 405px;
        .login {
          display: flex;
          flex-direction: column;
          padding: 0 30px;
          .title {
            font-size: $fontsize-large-xxx;
            font-weight: bold;
            padding: 0 0 20px;
          }
          .form {
            font-size: $fontsize-medium;
            /*设计图是40px*/
            padding-bottom: 20px;
            .row {
              display: flex;
              align-items: center;
              border-bottom: 1px solid $color-line-gray;
              padding: 10px 0;
              /*设计图是40px*/
              margin-bottom: 20px;
              .label {
                width: 60px;
              }
              .value {
                flex: 1;
              }
              .yzmbtn {
                color: $color-orange;
                cursor: pointer;
                font-size: $fontsize-medium-s;
              }
            }
          }
          .btn {
            text-align: center;
            border-radius: 40px;
            background-color: $color-orange;
            padding: 16px;
            font-size: $fontsize-large-x;
            color: #fff;
          }
          .lead {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: $fontsize-medium;
            /*设计图是padding: 30px 0 40px;*/
            padding: 25px 0 25px;
            span {
              cursor: pointer;
              color: $color-orange;
              border-bottom: 1px solid $color-orange;
            }
            & :first-child {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 769px) {
  .login_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-black;
    .container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: $color-black;
      /*padding-right: 40px;*/
      .box {
        border-radius: 3px;
        background-color: $color-bg-white;
        /*设计是425*/
        // width: 405px;
        .login {
          display: flex;
          flex-direction: column;
          padding: 0 30px;
          .title {
            font-size: $fontsize-large-xxx;
            font-weight: bold;
            padding: 0 0 20px;
          }
          .form {
            font-size: $fontsize-medium;
            /*设计图是40px*/
            padding-bottom: 20px;
            .row {
              display: flex;
              align-items: center;
              border-bottom: 1px solid $color-line-gray;
              padding: 10px 0;
              /*设计图是40px*/
              margin-bottom: 20px;
              .label {
                width: 60px;
              }
              .value {
                flex: 1;
              }
              .yzmbtn {
                color: $color-orange;
                cursor: pointer;
                font-size: $fontsize-medium-s;
              }
            }
          }
          .btn {
            text-align: center;
            border-radius: 40px;
            background-color: $color-orange;
            padding: 16px;
            font-size: $fontsize-large-x;
            color: #fff;
          }
          .lead {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: $fontsize-medium;
            /*设计图是padding: 30px 0 40px;*/
            padding: 25px 0 25px;
            span {
              cursor: pointer;
              color: $color-orange;
              border-bottom: 1px solid $color-orange;
            }
            & :first-child {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .login_wrapper {
    .container {
      .box {
        .login {
          .title {
            font-weight: bold;
            font-size: 2em;
            margin-bottom: .6em;
          }
          .form {
            .row {
              display: flex;
              flex-wrap: wrap;
              margin: 1.6em 0;
              align-items: center;
              border-bottom: 1px solid #ccc;
              .label {
                font-size: 1.2em;
                margin: .4em 0;
                width: 3.6em;
              }
              .value {
                margin: .4em 0;
              }
              .yzmbtn{
                font-size: .6em;
                color: #F46722;
              }
            }
          }
          .btn {
            text-align: center;
            border-radius: 5px;
            background-color: #F46722;
            margin: .5em .5em;
            height: 3em;
            line-height: 3em;
            color: #fff;
          }
          .lead {
            span{
              display: inline-block;
              color: #F46722;
              margin: .6em 0;
            }
          }
        }
      }
    }
  }
}
</style>